import { AtualizarContaBancariaDto } from "./dto/atualizar-conta-bancaria.dto";
import { BaseService } from "../base.service";
import { Endpoints } from "../../core/constants/endpoints";
import { NovaContaBancariaDto } from "./dto/nova-conta-bancaria.dto";

export class ContaBancariaService extends BaseService {
  async obterTodas() {
    try {
      return await this.api.get(Endpoints.contasBancarias, null);
    } catch (error) {
      throw error;
    }
  }
  async efetuarTransferencia(
    id: string,
    dto: { valor: number; contaDestino: string; contaOrigem: string }
  ) {
    try {
      return await this.api.post(
        `${Endpoints.contasBancarias}/${id}/transferencia`,
        dto
      );
    } catch (error) {
      throw error;
    }
  }
  async obterPorId(id: string) {
    try {
      return await this.api.get(`${Endpoints.contasBancarias}/${id}`);
    } catch (error) {
      throw error;
    }
  }
  async inativarCadastro(id: string) {
    try {
      return await this.api.patch(
        `${Endpoints.contasBancarias}/${id}/inativar`
      );
    } catch (error) {
      throw error;
    }
  }

  async criarContaBancaria(dto: NovaContaBancariaDto) {
    try {
      return await this.api.post(Endpoints.contasBancarias, dto);
    } catch (error) {
      throw error;
    }
  }
  async atualizarContaBancaria(id: string, dto: AtualizarContaBancariaDto) {
    try {
      return await this.api.patch(`${Endpoints.contasBancarias}/${id}`, dto);
    } catch (error) {
      throw error;
    }
  }

  async obterBancos(filtro: string) {
    try {
      return await this.api.get(`${Endpoints.bancos}?filtro=${filtro}`);
    } catch (error) {
      throw error;
    }
  }
}
